import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../styles/MenuPrincipal.css'
import '../index.css'
import texts from '../texts'

const MenuPrincipal = ({ vocabFile, setVocabFile, darkMode }) => {
  const navigate = useNavigate()
  const [categories, setCategories] = useState([])

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`/data/${vocabFile}`)
        const jsonData = await response.json()
        setCategories(Object.keys(jsonData))
      } catch (error) {
        console.error('Error al cargar las categorías:', error)
      }
    }

    fetchCategories()
  }, [vocabFile])

  // Opciones extra igual que en SideMenu
  const extraOptions = [
    { label: texts.menu.quizParticles, path: '/quiz-particulas' },
    { label: texts.menu.insertParticle, path: '/drag-drop' },
    { label: texts.menu.globalReview, path: '/global-review' },
    { label: texts.menu.search, path: '/buscar' }
  ]

  // Si quieres permitir cambiar el vocabulario desde aquí:
  return (
    <div className='menu-principal-container'>
      <h1 className='menu-titulo'>{texts.menu.welcome}</h1>
      <div className='menu-grid'>
        {categories.map((category, index) => (
          <div key={index} className='menu-card' onClick={() => navigate(`/flipcards/${category}`)}>
            {/* <div className='menu-icono' style={{ color: darkMode ? '#fff' : '#222' }}>
              <svg width='24' height='24' viewBox='0 0 24 24' fill='currentColor'>
                <path d='M7.5 5.6L5.6 7.5Q4.8 8.3 4.8 9.5Q4.8 10.7 5.6 11.5L7.5 13.4M9.5 3.7L11.4 5.6M13.4 5.6L15.3 7.5Q16.1 8.3 16.1 9.5Q16.1 10.7 15.3 11.5L13.4 13.4M11.5 1.8L13.4 3.7M7.5 18.4L5.6 16.5Q4.8 15.7 4.8 14.5Q4.8 13.3 5.6 12.5L7.5 10.6M9.5 20.3L11.4 18.4M13.4 18.4L15.3 16.5Q16.1 15.7 16.1 14.5Q16.1 13.3 15.3 12.5L13.4 10.6M11.5 22.2L13.4 20.3M16.1 9.5L18 11.4Q18.8 12.2 20 12.2Q21.2 12.2 22 11.4L22 11.4M14.2 7.6L16.1 5.7'/>
              </svg>
            </div> */}
            <h2>{category}</h2>
            {/* <p>{category}</p> */}
          </div>
        ))}
        {extraOptions.map((opt) => (
          <div key={opt.path} className='menu-card' onClick={() => navigate(opt.path)}>
            <h2>{opt.label}</h2>
          </div>
        ))}
      </div>
      <footer className='global-footer'>
        <span>© {new Date().getFullYear()} Japonés Quiz</span>
      </footer>
    </div>
  )
}

export default MenuPrincipal
